/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  maxMobile, maxTablet, minExtraLargeScreen,
  minStandardScreen, primaryColor, primaryFont,
  primaryHeadingColor, retina, secondaryFont, tabHeading, wMBold, wMedium, white,
} from 'Utils/utilsStyle';
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectCompanyBenefits } from 'Selector/CompaniesSelector';
import HealthHeartIcon from '../svgIcons/HealthHeartIcon';
import FinancialRetirementIcon from '../svgIcons/FinancialRetirementIcon';
import VacationTimeOffIcon from '../svgIcons/VacationTimeOffIcon';
import FamilyParentingIcon from '../svgIcons/FamilyParentingIcon';
import PerksandDiscountIcon from '../svgIcons/PerksandDiscountIcon';
import ProfessionalSupportIcon from '../svgIcons/ProfessionalSupportIcon';

const Wrapper = styled.div`
  margin-bottom: 27px;
  .company-benefits-heading {
    color: ${primaryHeadingColor};
    font-family: ${secondaryFont};
    font-size: 28px;
    font-style: normal;
    font-weight: ${wMBold};
    line-height: 47px;
    letter-spacing: -0.7px;
    margin-bottom: 16px;
    @media all and (max-width: ${maxMobile}) {
      line-height: 22px;
      font-size: 18px;
    }
  }
  .benefitsContentWrapper{
    display: flex;
    flex-direction: column;
    gap: 16px;
    @media all and (min-width: ${minExtraLargeScreen}) {
      gap: 20px;
    }
    @media all and (${retina}) {
    }
    @media all and (max-width: ${minStandardScreen}) {
      gap: 12px;
    }
    @media all and (max-width: ${maxTablet}) {
      gap: 10px;
    }
    @media screen and (max-width: ${maxMobile} ){
      gap: 8px;
    }
    .benefitsCategoryWrapper{
      padding: 24px 23px 24px 32px;
      display: flex;
      border-radius: 16px;
      background: ${white};
      box-shadow: 0px 0px 17px -2px rgba(0, 0, 0, 0.04);
      @media screen and (max-width: ${maxMobile} ){
        padding: 24px 16px 24px 16px;
        border-radius: 12px;
        flex-direction: column;
      }
      .categoryBox{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
        width: 100%;
        max-width: 150px; // After adding 24px padding from right and Border of 1px
        border-right: 1px solid #DADADA;
        padding-right: 24px;
        min-height: 111px;
        @media screen and (max-width: ${maxMobile} ){
          padding: 0;
          border-right: none;
          border-bottom: 1px solid #DADADA;
          gap: 8px;
          padding-bottom: 16px;
          margin-bottom: 24px;
          max-width: 100%;
          min-height: unset;
        }
        .categoryIcon{
          border-radius: 50%;
          overflow: hidden;
          min-height: 32px;
          max-height: 32px;
          min-width: 32px;
          max-width: 32px;
          @media screen and (max-width: ${maxMobile} ){
            min-height: 25px;
            max-height: 25px;
            min-width: 25px;
            max-width: 25px;
          }
          svg,img{
            height: 100%;
            width: 100%;
          }
        }
        .benefitHeading{
          color: ${primaryHeadingColor};
          text-align: center;
          font-family: ${primaryFont};
          font-size: 16px;
          font-style: normal;
          font-weight: ${wMedium};
          line-height: 20px;
          letter-spacing: -0.333px;
          @media screen and (max-width: ${maxMobile} ){
            font-size: 14px;
            max-width: 110px;
          }
        }
      }
      .benefitsTextBox{
        display: flex;
        align-items: flex-start;
        align-self: center;
        flex-wrap: wrap;
        flex: 1;
        gap: 24px 14px;
        padding: 10px 0 10px 24px;
        @media screen and (max-width: ${maxMobile} ){
          font-size: 14px;
          padding: 0;
          width: 100%;
        }
        .benefitText{
          color: #67696A;
          font-family: ${primaryFont};
          font-size: 16px;
          font-style: normal;
          font-weight: ${wMedium};
          line-height: normal;
          display: flex;
          align-items: flex-start;
          gap: 6px;
          min-width: 218px;
          max-width: 218px;
          @media all and (max-width: ${minStandardScreen}) {
            min-width: 200px;
            max-width: 200px; 
          }
          @media screen and (max-width: ${maxMobile} ){
            font-size: 14px;
            min-width: 138px;
            max-width: 138px; 
          }
          &::before{
            content: '';
            display: inline-flex;
            min-height: 8px;
            max-height: 8px;
            min-width: 8px;
            max-width: 8px;
            background-color: ${primaryColor};
            border-radius: 50%;
            margin-top: 5px; //Just to allign with text
          }
        }
      }
    }
  }
`;

const getIcon = (title: string) => {
  switch (title) {
    case 'Insurance Health and Wellness':
      return <HealthHeartIcon />;
    case 'Financial & Retirement':
      return <FinancialRetirementIcon />;
    case 'Family & Parenting':
      return <FamilyParentingIcon />;
    case 'Vacation & Time Off':
      return <VacationTimeOffIcon />;
    case 'Perks & Discounts':
      return <PerksandDiscountIcon />;
    case 'Professional Support':
      return <ProfessionalSupportIcon />;
    default:
      return <PerksandDiscountIcon />;
  }
};

const Benefits = function Benefits() {
  const companyBenefits = useSelector(selectCompanyBenefits);
  return (
    <Wrapper id="tabs-details">
      <div className="company-benefits-heading">
        Benefits
      </div>
      <div className="benefitsContentWrapper">
        {companyBenefits && companyBenefits.map((category, i) => (
          <div key={`${i + 1}`} className="benefitsCategoryWrapper">
            <div className="categoryBox">
              <span className="categoryIcon">
                {getIcon(category.title)}
              </span>
              <div className="benefitHeading">{category.title}</div>
            </div>
            <div className="benefitsTextBox">
              {category?.details.length > 0
                && category.details.map((detail, index) => (
                  <div key={`${index + 1}`} className="benefitText">
                    <span className="text-truncate-two-line">{detail}</span>
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>
    </Wrapper>
  );
};

export default React.memo(Benefits);
